export interface PromptDto {
  id: number;
  title: string;
  text: string;
}

export const DEFAULT_PROMPT = {
  title: '',
  text: '',
};
